
export class GenericCounterGraphData {
    public instanceGuid: string = "";
    public address: string = "";
    public data: Array<any> = new Array<any>();

    constructor () { }
}